import { COLORS } from "../../../../Diathrive/src/utils/Constants";

const styles = {
  mainContainer: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    height: "100vh",
    justifyContent: "space-between",
  },
  diathrive_logo: {
    marginLeft: "24px",
    paddingTop: "24px",
  },
  divider: {
    height: "0px",
    border: `0.5px solid ${COLORS.greyLight}`,
    flex: "none",
    order: 3,
    flexGrow: 0,
    margin: "24px 12px",
  },
  modalViewStyle: { maxWidth: 371 },
  active: {
    background: "rgba(74, 166, 225, 0.05)",
    borderLeft: `4px solid ${COLORS.blueMain1}`,
    boxSizing: "border-box",
    flex: "none",
    order: 3,
    flexGrow: 0,
  },
  spIconText: {
    display: "flex",
    cursor: "pointer",
    alignItems: "center",
    gap: "16px",
  },
  spIcon: {
    padding: 2,
    justifyContent: "center",
    alignItems: "center",
    width: 24,
    height: 24,
  },
  listItem: {
    padding: 16,
  },
  navLink: {
    textDecoration: "none",
  },
  imageProfileTextContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "2px",
    overflow: "auto",
    flex: 1,
  },
  imageProfileDevider: {
    marginTop: "24px",
  },
  imageProfile: {
    display: "flex",
    gap: "12px",
    cursor: "pointer",
    padding: "16px",
  },
  signout: {
    backgroundColor: COLORS.red,
    width: "131.5px",
    height: "56px",
    marginLeft: "24px",
  },
  cancel: {
    width: "131.5px",
    height: "56px",
  },
};

export default styles;
